/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorAcceptCodeLabelTypename = "PharmacyCounselorAcceptCodeLabel" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorAcceptCodeLabel
 */
export interface PharmacyCounselorAcceptCodeLabel {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorAcceptCodeLabel
   */
  acceptCodeLaneType: PharmacyCounselorAcceptCodeLabelAcceptCodeLaneTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorAcceptCodeLabel
   */
  label: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorAcceptCodeLabel
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorAcceptCodeLabelAcceptCodeLaneTypeEnum {
  Normal = "normal",
  Quick = "quick",
}

export function PharmacyCounselorAcceptCodeLabelFromJSON(json: any): PharmacyCounselorAcceptCodeLabel {
  return PharmacyCounselorAcceptCodeLabelFromJSONTyped(json, false);
}

export function PharmacyCounselorAcceptCodeLabelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorAcceptCodeLabel {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorAcceptCodeLabelTypename,

    acceptCodeLaneType: json["accept_code_lane_type"],
    label: json["label"],
  };
}

export function PharmacyCounselorAcceptCodeLabelToJSON(object?: PharmacyCounselorAcceptCodeLabel | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code_lane_type: value.acceptCodeLaneType,
    label: value.label,
  };
}
